import InputCus from "../../Component/InputCus/Text/InputCus";
import { useEffect, useState } from "react";
import {
  CompetitorDeleteCompetitor,
  CompetitorFilterCompetitor,
  CompetitorIsAutoCompetitor,
  CompetitorChangeOrderCompetitor,
  CompetitorChangeIsAceess,
} from "../../Api/Services";
import ShowDeImg from "../../assets/Icon/icons8-details-50.png";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Toggle from "react-toggle";
import Select from "../../Component/InputCus/Select/Select";
import imgIdentity from "../../assets/Icon/icons8-identity-64.png";

function Competitors() {
  const [Search, setSearch] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  let { id } = useParams();

  const start = async () => {
    try {
      const CompetitorFilterCompetitorData = await CompetitorFilterCompetitor({
        competitorCategoryId: id,
      });
      if (
        CompetitorFilterCompetitorData.status &&
        CompetitorFilterCompetitorData.status === 200
      ) {
        setData(CompetitorFilterCompetitorData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const Clear = async () => {
    setSearch({});
    setLoading(true);
    try {
      const CompetitorFilterCompetitorData = await CompetitorFilterCompetitor({
        competitorCategoryId: id,
      });
      if (
        CompetitorFilterCompetitorData.status &&
        CompetitorFilterCompetitorData.status === 200
      ) {
        setData(CompetitorFilterCompetitorData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Searched = async () => {
    try {
      setLoading(true);
      let searching = { ...Search };
      const CompetitorFilterCompetitorData = await CompetitorFilterCompetitor({
        ...searching,
        competitorCategoryId: id,
      });
      if (
        CompetitorFilterCompetitorData.status &&
        CompetitorFilterCompetitorData.status === 200
      ) {
        setData(CompetitorFilterCompetitorData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف مرجع",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const IdentityCom = (e) => {
    navigate("/Panel/Competitors/IdentityCom/" + e+"/"+id);
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const CompetitorDeleteCompetitorData =
        await CompetitorDeleteCompetitor(e);
      if (
        CompetitorDeleteCompetitorData.status &&
        CompetitorDeleteCompetitorData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const ChangeIsAceessBtn = async (e) => {
    try {
      setLoading(true);
      const CompetitorChangeIsAceessData = await CompetitorChangeIsAceess(e);
      if (
        CompetitorChangeIsAceessData.status &&
        CompetitorChangeIsAceessData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const IsAutoItem = async (e) => {
    try {
      setLoading(true);
      const CompetitorIsAutoCompetitorrData =
        await CompetitorIsAutoCompetitor(e);
      if (
        CompetitorIsAutoCompetitorrData.status &&
        CompetitorIsAutoCompetitorrData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate(`/Panel/Competitors/Add/${id}`);
  };

  const Edite = (extraParam) => {
    navigate(`/Panel/Competitors/Edite/${id}/${extraParam}`);
  };
  const ShowProduct = (extraParam) => {
    navigate(`/Panel/Competitors/Product/${id}/${extraParam}`);
  };

  const handleChangeSearch = (e) => {
    const newSearch = { ...Search };
    newSearch[e.target.id] = e.target.value;
    setSearch(newSearch);
  };

  const ChandeOrder = async (e) => {
    const newSearch = [...data];
    newSearch.find((w) => w.id == e.target.id).order = e.target.value;
    setData(newSearch);
  };

  const FixChandeOrder = async (e) => {
    if (e.key == "Enter") {
      try {
        setLoading(true);
        const CompetitorChangeOrderCompetitorData =
          await CompetitorChangeOrderCompetitor({
            id: e.target.id,
            order: e.target.value,
          });
        if (
          CompetitorChangeOrderCompetitorData.status &&
          CompetitorChangeOrderCompetitorData.status === 200
        ) {
          toast.success("عملیات با موفقیت انجام شد");
          await start();
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
      }
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-start align-items-center flex-wrap">
            <InputCus
              type="text"
              name="name"
              id="name"
              text="نام"
              className="m-2"
              value={Search.name || ""}
              onChange={handleChangeSearch}
            />
            <Select
              type="text"
              name="isAuto"
              id="isAuto"
              text="اتوماتیک"
              value={Search.isAuto || ""}
              onChange={handleChangeSearch}
              className="m-2"
              option={[
                { value: true, title: "فعال" },
                { value: false, title: "غیرفعال" },
              ]}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center w-100 mb-3">
            <div onClick={Searched} className="btnSearch">
              جست و جو
            </div>
            <div onClick={Clear} className="btnCancel">
              بروزرسانی
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>الویت نمایش</th>
                  <th>نام</th>
                  <th>اتوماتیک با ثبت نام</th>
                  <th>اتوماتیک</th>
                  <th>Id Out</th>
                  <th>هر چند ساعت</th>
                  <th>وضعیت اخرین درخواست</th>
                  <th>VIP(desc)</th>
                  <th>اخرین درخواست</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <input
                        id={item.id}
                        className="w-25"
                        value={item.order}
                        onKeyUp={(e) => FixChandeOrder(e)}
                        onChange={(e) => ChandeOrder(e)}
                      />
                    </td>
                    <td>{item.name}</td>
                    <td>
                      <Toggle
                        id={item.id + ""}
                        checked={item.isAceess}
                        onChange={() => ChangeIsAceessBtn(item.id)}
                      />
                    </td>
                    <td>
                      <Toggle
                        id={item.id + ""}
                        checked={item.isAuto}
                        onChange={() => IsAutoItem(item.id)}
                      />
                    </td>
                    <td>{item.idAuto}</td>
                    <td>{item.repeatAuto}</td>
                    <td>{item.isResultLastAuto ? "موفق" : "ناموفق"}</td>
                    <td>{item.description && "VIP"}</td>
                    <td>{item.lastFetchTimeAuto}</td>
                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="کالا ها"
                      >
                        <img
                          height="30"
                          src={ShowDeImg}
                          alt="کالا ها"
                          onClick={() => {
                            ShowProduct(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer m-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title=" دسترسی به مراجع"
                      >
                        <img
                          height="40"
                          src={imgIdentity}
                          alt="دسترسی به مراجه"
                          onClick={() => {
                            IdentityCom(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Competitors;
